import React from 'react';

export function AkademijaPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 py-4 sm:py-8">
        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 mb-4 sm:mb-6 text-center px-2">
          Akademija izvrsnosti za onkološke medicinske sestre i tehničare 2025
        </h1>
        
        {/* Open PDF button for mobile */}
        <div className="flex justify-center mb-4 sm:hidden">
          <a
            href="/Program.Akademija izvrsnosti za onkoloske medicinske sestre i tehnicare 2025.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-6 rounded-lg shadow-md transition-colors"
          >
            Otvori PDF
          </a>
        </div>
        
        <div className="bg-white rounded-lg shadow-lg p-1 sm:p-4">
          <iframe
            src="/Program.Akademija izvrsnosti za onkoloske medicinske sestre i tehnicare 2025.pdf"
            className="w-full h-[500px] sm:h-[600px] md:h-[700px] lg:h-[800px] border-0 rounded"
            title="Program Akademije izvrsnosti"
          />
        </div>
      </div>
    </div>
  );
}

